<template>
    <div class="col-12">
        <!-- eslint-disable-next-line -->
        <b-modal id="showSucursal" v-model="showModal" size="xl" centered no-close-on-esc no-close-on-backdrop hide-header-close
        title-class="font-18" title="Detalle de validaciones">
            <template v-slot:default>
                 <div class="row">
                    <div class="table-responsive">
                        <table class="table align-middle table-bordered">
                            <thead class="table-light">
                                <th>
                                    Clave validación
                                </th>
                                <th>
                                    Ejecutada
                                </th>
                                <th>
                                    Pasada
                                </th>
                                <th>
                                    Error de validación
                                </th>
                                <th>
                                    Fecha validación
                                </th>
                            </thead>
                            <tbody>
                                <tr class="table-hover" v-for="item in stageHistoryConDescripcionDeClavesValidacion" :key="item.index">
                                    <td>{{ item.name }} {{ item.descripcion_clave }}</td>                                    
                                    <td>
                                        <span class="badge" :class="item.executed == true ? 'bg-success' : 'bg-danger'">
                                            {{ item.executed == true ? "Si" : "No" }}
                                        </span>
                                    </td>
                                    <td>
                                        <span class="badge" :class="item.passed == true ? 'bg-success' : 'bg-danger'">
                                            {{item.passed == true ? "Si" : "No" }}
                                        </span>
                                    </td>
                                    <td>{{ item.validation_error == null ? "Sin error" : item.validation_error }}</td>
                                    <td>{{ item.created_at }}</td>
                                </tr>
                            </tbody>
                        </table>                        
                    </div>                    
                 </div>
                <!-- <div class="row"> -->
                    <!-- :callback-search="getDireccionesPag" -->
                    <!-- <table-pagination 
                            :headers="headers" 
                            :pagination="pagination"
                            @on-pagination="pagination = $event"
                        >
                            <template v-slot:tbody>
                                <tr class="table-hover" v-for="item in stage_history.stages" :key="item.index">
                                    <td>{{ item.name }}</td>                                    
                                    <td>{{ item.executed }}</td>
                                    <td>{{ item.passed }}</td>
                                    <td>{{ item.validation_error }}</td>
                                </tr>
                            </template>
                    </table-pagination> -->
                <!-- </div> -->
            </template>
            <template v-slot:footer>
                <button class="btn btn-danger" @click="emitirHide" title="Cerrar modal">
                    Cerrar
                </button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { ModalMix } from './../../../../mixes/ModalMix';

const headers = [
  {
    index: "clave_validacion",
    label: "Clave validación",
    filter: false,
  },
  {
    index: "ejecutada",
    label: "Ejecutada",
    filter: false,
    selected: false,
  },
  {
    index: "pasada",
    label: "Pasada",
    filter: false,
    selected: false,
  },
  {
    index: "descripcion",
    label: "Descripción",
    filter: false,
    selected: false,
  }
];

export default{
    mixins: [ModalMix],
    props: {
        stage_history: Object,
        showModal:{
            type: Boolean,
            default: false,
        }
    },
    data(){
        return{
            headers,
        }
    },
    methods:{
        emitirHide() {
            this.$emit('on-hide', true);
        }
    },
    computed: {
        // eslint-disable-next-line
        stageHistoryConDescripcionDeClavesValidacion() {
            const descpricion_claves_validacion = [
                { B00: "Es un base 64"},
                { B01: "Es un XML" },
                { B02: "Es un CFDI" },
                { B03: "Validacion integridad basada en timbre(no fue alterado)" },
                { B04: "Validacion RFC receptor" },
                { B05: "Validacion RFC proveedor basado en catalogo, que este activo" },
                { B06: "Validacion de que el RFC de proveedor coincide con el RFC del proveedor autenticado" },
                { B07: "Validar que CFDI no este ya archivado" },
                { SAT01: "Validación comprobante vigencia SAT como activo" },
                { BLACKLST_69B: "Listas negras: 69B" },
                { ADD_00: "Contenga addenda (Ingreso y Egreso)" },
                { ADD_01: "Validar que contenga solo 1 nodo addenda" },
                { ADD_724_0A: "Validar que contenga nodo Referencia724 en addenda" },
                { ADD_724_0B: "Verificacion de nodo, debe existir 1 nodo referencia" },
                { ADD_724_01: "Validacion addenda estructura (campos requerido y tipo de dato)" },
                { ADD_724_02: "Validacion addenda RFC emisor longitud, basado de catalogo y activo" },
                { ADD_724_03: "Validacion addenda sucursal exista en catalogo y activa" },
                { ADD_724_04: "RFC emisor es igual a RFC emisor addenda" },
                { ADD_724_05: "La addenda se actualiza solo si el CFDI fue aceptado" },
                { CP00: "Es un CP valido en estructura" },
                { CP01: "UUID de factura original existe / validacion por pago" },
                { CP02: "Validacion CFDI Pago no existe en el sistema (duplicado)" },
                { CP_SAT01: "UUID de factura original existe siga vigente (no cancelada)" },
                { CP03: "Validación de CFDI original está 'validado' y 'leido' y que no este en estado 'SALDADO/LIQUIDADO'" },
                { CP04: "Validación monto de importe pagado no sea mayor al total del PPD." },
                { CP05: "Validacion importe pagado actual mas posibles imp pagados 'archivados' no es mayor al monto total del CFDI pendiente de pago" },
                { CP06: "Validacion impuestos" }
            ];

            if (
                this.stage_history !== null &&
                this.stage_history !== undefined &&
                this.stage_history.stages !== null &&
                this.stage_history.stages !== undefined
            ) {
                return this.stage_history.stages.map(validacion => {
            
                    const descripcion_obj = descpricion_claves_validacion.find(entry => entry[validacion.name]);
                    const descripcion_clave_validacion = descripcion_obj
                        ? descripcion_obj[validacion.name]
                        : "Clave de validación desconocida";

                    return {
                        ...validacion,
                        descripcion_clave: descripcion_clave_validacion
                    };
                });
            }
        }
    }
}
</script>